"use client";

import { c as _c } from "react/compiler-runtime";
import { useDebouncedEffect } from "@react-hookz/web";
import Form from "next/form";
import type { Usable } from "react";
import { useActionState } from "react";
import { SlEnvolope } from "react-icons/sl";
import type { ResolvedIntlConfig } from "react-intl";
import { toast } from "sonner";
import { useAnalytics } from "use-analytics";
import { Button } from "@repo/components/atoms/shadcn/button";
import { LoadingDots } from "@repo/components/atoms/loading-dots";
import { useGetIntl } from "@repo/i18n/intl/client";
import { subscribeToNewsletterAction } from "@repo/klaviyo/actions";
import { cn } from "@repo/lib";
export function SubscribeToNewsletterForm(t0) {
  const $ = _c(53);
  const {
    className,
    dictionaryPromise,
    lang
  } = t0;
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  const {
    track
  } = useAnalytics() || {};
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [formState, formAction, isPending] = useActionState(subscribeToNewsletterAction, t2);
  let t3;
  if ($[4] !== formState.data?.success || $[5] !== formState.serverError || $[6] !== intl || $[7] !== track) {
    t3 = () => {
      if (formState.serverError) {
        toast.error(intl.formatMessage({
          id: "YvzLzo",
          defaultMessage: "Unable to subscribe to the newsletter",
          description: "Error message title"
        }), {
          description: intl.formatMessage({
            id: "Lvs2Oi",
            defaultMessage: "The action failed with the following error: {message}",
            description: "Text for an unsuccessful subscribe status message"
          }, {
            message: formState.serverError || "Unknown error"
          })
        });
        track("newsletter_subscribe_form", {
          status
        });
      }
      if (formState.data?.success === true) {
        toast.success(intl.formatMessage({
          id: "wU7flt",
          defaultMessage: "Successfully subscribed",
          description: "Success message title"
        }), {
          description: intl.formatMessage({
            id: "DC5idF",
            defaultMessage: "You have successfully subscribed to the newsletter",
            description: "Text for successful subscription status message"
          })
        });
        track("newsletter_subscribe_form", {
          status
        });
      }
    };
    $[4] = formState.data?.success;
    $[5] = formState.serverError;
    $[6] = intl;
    $[7] = track;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = formState.data?.message;
  let t5;
  if ($[9] !== formState.serverError || $[10] !== isPending || $[11] !== t4) {
    t5 = [isPending, t4, formState.serverError];
    $[9] = formState.serverError;
    $[10] = isPending;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useDebouncedEffect(t3, t5, 200, 500);
  let t6;
  if ($[13] !== className) {
    t6 = cn("grid gap-4", className);
    $[13] = className;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== formState.serverError) {
    t7 = cn("relative grid items-center", {
      "border-destructive": formState.serverError
    });
    $[15] = formState.serverError;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = Boolean("success" in formState && formState.success === false);
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("border-none ring-accent px-4 py-4");
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== intl) {
    t10 = intl.formatMessage({
      id: "c89vOg",
      defaultMessage: "Enter your email",
      description: "Placeholder for email input"
    });
    $[18] = intl;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== isPending || $[21] !== t10 || $[22] !== t8) {
    t11 = <input aria-invalid={t8} autoComplete="email" className={t9} disabled={isPending} name="email" placeholder={t10} type="email" />;
    $[20] = isPending;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== intl || $[25] !== isPending) {
    t12 = isPending ? <LoadingDots className="absolute justify-self-end end-3" /> : <Button aria-label={intl.formatMessage({
      id: "GMz2WV",
      defaultMessage: "Subscribe",
      description: "Text for subscribe button aria-label"
    })} className="btn absolute justify-self-end end-3" disabled={isPending} variant="ghost"><SlEnvolope /></Button>;
    $[24] = intl;
    $[25] = isPending;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12 || $[29] !== t7) {
    t13 = <div className={t7}>{t11}{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t7;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== lang) {
    t14 = <input type="hidden" name="lang" value={lang} />;
    $[31] = lang;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== intl) {
    t15 = intl.formatMessage({
      id: "nqhMlh",
      defaultMessage: "Subscribe",
      description: "Text for subscribe button"
    });
    $[33] = intl;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== className || $[36] !== isPending || $[37] !== t15) {
    t16 = <Button className={className} disabled={isPending} type="submit" variant="default">{t15}</Button>;
    $[35] = className;
    $[36] = isPending;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== intl) {
    t17 = intl.formatMessage({
      id: "a8+g1G",
      defaultMessage: "Reset",
      description: "Text for reset button"
    });
    $[39] = intl;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== className || $[42] !== isPending || $[43] !== t17) {
    t18 = <Button className={className} disabled={isPending} type="reset" variant="secondary">{t17}</Button>;
    $[41] = className;
    $[42] = isPending;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t16 || $[46] !== t18) {
    t19 = <div className="actions grid grid-flow-col gap-4">{t16}{t18}</div>;
    $[45] = t16;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t13 || $[49] !== t14 || $[50] !== t19 || $[51] !== t6) {
    t20 = <Form action={formAction} className={t6}>{t13}{t14}{t19}</Form>;
    $[48] = t13;
    $[49] = t14;
    $[50] = t19;
    $[51] = t6;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
}